import { styled } from 'styled-components';

import { EOrderStatus } from '@/types/orders';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    width: 285px;
    height: 100%;
    display: flex;
    flex-direction: column;
    ${mq.lt.md} {
        width: 100%;
    }
`;

export const Info = styled.div`
    flex-grow: 1;

    ${mq.lt.md} {
        margin-bottom: 6px;
    }
`;

export const ButtonBox = styled.div<{ status: EOrderStatus }>`
    display: flex;
    place-content: end end;
    margin: 8px 0 0;

    button {
        font-size: 12px;
        ${({ status, theme }) =>
            (status === EOrderStatus.Delayed || status === EOrderStatus.Sent_to_court) &&
            `background: ${theme.color.error};`}
    }
    ${mq.lt.md} {
        justify-content: start;

        button {
            width: 100%;
            height: 44px;
        }
    }
`;
